import request from '@/utils/httpRequest'
/*
 * @author: xz
 * @date: 2021/04/30
 * */
/*
 * @Description: 本地视听列表
 * */
export function getLiveList (query) {
  return request({
    url: '/api/culture/cultureDistribution/web/liveData/page',
    method: 'get',
    params: query
  })
}
/*
 * @Description: 本地视听详情
 * */
export function getLiveDetail (id) {
  return request({
    url: '/api/culture/cultureDistribution/web/liveData/' + id,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/live/index.js